var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 0C6.73 0 0 6.73 0 15s6.73 15 15 15 15-6.73 15-15S23.27 0 15 0zm12.116 9.506-6.337 2.364a6.616 6.616 0 0 0-2.649-2.648l2.365-6.338a13.386 13.386 0 0 1 6.62 6.622zM15 19.883A4.888 4.888 0 0 1 10.118 15 4.886 4.886 0 0 1 15 10.12 4.887 4.887 0 0 1 19.882 15 4.889 4.889 0 0 1 15 19.883zm-5.495-17 2.366 6.339a6.62 6.62 0 0 0-2.65 2.648L2.884 9.505a13.386 13.386 0 0 1 6.621-6.621zm-6.62 17.612L9.22 18.13a6.621 6.621 0 0 0 2.649 2.649l-2.365 6.337a13.375 13.375 0 0 1-6.62-6.62zm17.61 6.62L18.13 20.78a6.614 6.614 0 0 0 2.649-2.65l6.337 2.366a13.38 13.38 0 0 1-6.621 6.62z",
    fill: "#000",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.b862364a4a4d5722f0ecb601485108d4.svg";
export { ForwardRef as ReactComponent };